import { ABI_VERSION } from "@dopejs/pingo-host";
/** Engine release version for incident reports and rollout dashboards. */
export const ENGINE_VERSION = "0.4.0";
/** Binary protocol version negotiated across the Shell/Core boundary. */
export const ENGINE_ABI_VERSION = ABI_VERSION;
/** Structured identity attached to error reports and qualification evidence. */
export function engineIdentity() {
    return { version: ENGINE_VERSION, abiVersion: ENGINE_ABI_VERSION };
}
//# sourceMappingURL=version.js.map